import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
// import { Link } from "react-router-dom";
import { BrowserRouter } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";
import { CiCreditCard2 } from "react-icons/ci";
import { HiAcademicCap } from "react-icons/hi";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <BrowserRouter>
      <Navbar
        expanded={expand}
        fixed="top"
        expand="md"
        className={navColour ? "sticky" : "navbar"}
      >

        <Container>
          <Navbar.Brand href="/" className="d-flex">
            {/* <img src={logo} className="img-fluid logo" alt="brand" /> */}
            <h1 className="logo-text">keshavOP</h1>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => {
              updateExpanded(expand ? false : "expanded");
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" defaultActiveKey="#home">

              {/* <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item> */}

              <Nav.Item>
                <Link to='#home' smooth className='nav-link' Home
                  onClick={() => updateExpanded(false)}
                >
                  <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
                </Link>
              </Nav.Item>

              <Nav.Item>
                <Link to='#about' smooth className='nav-link' About
                  onClick={() => updateExpanded(false)}
                >
                  <AiOutlineUser style={{ marginBottom: "2px" }} /> About
                </Link>
              </Nav.Item>



              <Nav.Item>
                <Link to='#experience' smooth className='nav-link' Projects
                  onClick={() => updateExpanded(false)}

                >
                  <HiAcademicCap
                    style={{ marginBottom: "2px" }}
                  />
                  Experience
                </Link>
              </Nav.Item>

              <Nav.Item>
                <Link to='#project' smooth className='nav-link' Projects
                  onClick={() => updateExpanded(false)}

                >
                  <AiOutlineFundProjectionScreen
                    style={{ marginBottom: "2px" }}
                  />
                  Projects
                </Link>
              </Nav.Item>

              {/* <Nav.Item>
                <Link to='#contact' smooth className='nav-link' Projects
                  onClick={() => updateExpanded(false)}

                >
                  <AiOutlineContacts
                    style={{ marginBottom: "2px" }}
                  />
                  Contact-us
                </Link>
              </Nav.Item> */}

              <Nav.Item>
                <Nav.Link
                  href="https://kkcertificatewebsite.vercel.app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <CiCreditCard2 style={{ marginBottom: "2px" }} /> Certifications
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  href="http://bit.ly/3Fi11hf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
                </Nav.Link>
              </Nav.Item>






            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </BrowserRouter >
  );
}

export default NavBar;
